import React from "react";

const ModalVideos = ({ isOpen, onClick, videoId = "Faow3SKIzq0" }) => {
  if (!isOpen) return null;

  const close = () => onClick?.();

  const onBackdropClick = (e) => {
    // Cierra solo si hacen click fuera del video
    if (e.target === e.currentTarget) close();
  };

  return (
    <div
      onClick={onBackdropClick}
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: 24,
      }}
    >
      <div
        style={{
          width: "min(960px, 100%)",
          aspectRatio: "16 / 9",
          background: "#000",
          borderRadius: 12,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <button
          type="button"
          onClick={close}
          aria-label="Cerrar video"
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 2,
            border: "none",
            borderRadius: 999,
            width: 40,
            height: 40,
            cursor: "pointer",
            background: "rgba(255,255,255,0.15)",
            color: "#fff",
            fontSize: 22,
            lineHeight: "40px",
          }}
        >
          ×
        </button>

        <iframe
          title="Vídeo"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
          style={{ width: "100%", height: "100%", border: 0 }}
        />
      </div>
    </div>
  );
};

export default ModalVideos;
